/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
// material
import { Control, Group, ImageUploader, TextField } from '@insticator/insticator-ui'; // iui-material
import SectionCard from '../../../../../../material/expandablesection/sectioncard/sectioncard';
import SectionGroup from '../../../../../../material/expandablesection/sectiongroup/sectiongroup';
import SectionGroupDescription from '../../../../../../material/expandablesection/sectiongroupdescription/sectiongroupdescription';
// styles
import injectSheet from 'react-jss';
import styles from './general_styles';
import {
  ARTICLE_DISPLAY_LIST,
  DEFAULT_TRENDING_TITLE,
  FLAT_ARTICLES_AMOUNT_LIST,
  METHOD_TO_SELECT_LIST,
  PLACEHOLDER_IMAGES_LIST,
  RAIL_ARTICLES_AMOUNT_LIST,
  TIME_RANGE_LIST
} from "../../../../../../state/slices/engagement";

import ControlsTooltips from '../tooltips/tooltips'
import { tooltipsContent } from '../tooltips/tooltips_content'

export const TRENDING_TITLE_MAX_LENGTH = 15;

/* ========== ~~~~~~~~~~ GENERAL CONFIGS - TRENDING ~~~~~~~~~~ ========== */
const GeneralConfigs = injectSheet(styles)((props) => {
  const {
    handleChangeTitle,
    handleChangeTimeRange,
    handleChangeSelectArticles,
    handleChangeDisplayView,
    handleChangeAmountArticles,
    handleChangePlaceholderImages,
    handleUploadImage,
    config,
    modalIsOpened,
  } = props;

  const [uploadImagePreview, setUploadImagePreview] = useState(config.placeholder_img_url);

  const handleUpload = (value) => {
    setUploadImagePreview(URL.createObjectURL(value))
    handleUploadImage({placeholder_img_file: value})
  }

  const handleDiscard = () => {
    // cleanup fields, select default on discard
    setUploadImagePreview(null)
    handleUploadImage({placeholder_img_file: '', placeholder_img_url: '', isCustomImage: 'STANDARD'})
  }

  const selectedArticleDisplay = (typeView) => {
    return modalIsOpened ? typeView === 'SCROLL_WITH_AD' : typeView === config.display;
  }

  return (
    <SectionCard klass={props.classes.generalconfig}>
      <SectionGroup>
        <SectionGroupDescription
          title='Title (15 max characters)'
          titleClassName={'inline'}
          descriptionClassName={'inline'}
        />
        <TextField 
          name={'title'}
          type={'text'}
          value={config.titleTrending}
          handleChange={handleChangeTitle}
          placeholder={DEFAULT_TRENDING_TITLE}
          maxLength={TRENDING_TITLE_MAX_LENGTH}
        />
        {/* <div className="formelement">
          <input
            maxLength={TRENDING_TITLE_MAX_LENGTH}
            className="textfield"
            type="text" name="title"
            value={config.titleTrending}
            onChange={handleChangeTitle}
            placeholder={DEFAULT_TRENDING_TITLE}
          />
        </div> */}
      </SectionGroup>
      <SectionGroup>
        <SectionGroupDescription
          title='Method to select articles'
        />
        <Group name={'controls advance'}>
          {METHOD_TO_SELECT_LIST.map(i =><React.Fragment key={i.title}>
            <Control
              key={i.value}
              text={i.title}
              value={i.value}
              selected={i.value === config.selection_method}
              handleSelect={() => handleChangeSelectArticles({selection_method: i.value})}
              variant={'secondary'}
              addCheckWhenSelected={true}
            />
            <ControlsTooltips
              key={`${i.value}-control`}
              order={i.order}
              bottomVisible={false}
              tooltipsContent={tooltipsContent.methodToSelect}
              isChecked={i.value === config.selection_method}
              />
          </React.Fragment>)}
        </Group>
      </SectionGroup>
      <SectionGroup>
        <SectionGroupDescription
          title='Article display'
        />
        <Group name={'controls view'}>
          {ARTICLE_DISPLAY_LIST.map(i => <React.Fragment key={i.title}>
            <Control
              key={i.value}
              text={i.title}
              value={i.value}
              selected={selectedArticleDisplay(i.value)}
              handleSelect={() => !modalIsOpened && handleChangeDisplayView({display: i.value})}
              variant={'secondary'}
              addCheckWhenSelected={true}
            />
            <ControlsTooltips
              key={`${i.value}-control`}
              order={i.order}
              bottomVisible={true}
              tooltipsContent={tooltipsContent.display}
              isChecked={selectedArticleDisplay(i.value)}
              />
          </React.Fragment>)}
        </Group>
      </SectionGroup>
      {config.display === "FLAT" && <SectionGroup>
        <SectionGroupDescription
          description='Define how many Top 10 articles should be loaded by default'
        /><div className='square-button'>
        <Group name={'controls amount'}>

            {FLAT_ARTICLES_AMOUNT_LIST.map(i => <Control
              key={i.value}
              text={i.title}
              value={i.value}
              selected={i.value === config.visible_amount}
              handleSelect={() => handleChangeAmountArticles({visible_amount: i.value})}
              variant={'secondary'}
              addCheckWhenSelected={true}
            />) }

        </Group></div>
      </SectionGroup> }
      { config.display === "RAIL_SCROLL" && <SectionGroup>
        <SectionGroupDescription
          description="Define how many Top 10 articles should be visible by default"
        />
        <div className="square-button">
          <Group name={ 'controls amount' }>

            { RAIL_ARTICLES_AMOUNT_LIST.map(i => <Control
              key={ i.value }
              text={ i.title }
              value={ i.value }
              selected={ i.value === config.visible_amount }
              handleSelect={ () => handleChangeAmountArticles({ visible_amount: i.value }) }
              variant={ 'secondary' }
              addCheckWhenSelected={ true }
            />) }
          </Group></div>
      </SectionGroup> }
      <SectionGroup>
        <SectionGroupDescription
          title='Top 10 Trending Timeframe'
          description='Select the timeframe used to aggregate engagement metrics that will drive logic to determine Top 10 Trending articles'
        />
        <Group name={'controls top'}>
          {TIME_RANGE_LIST.map(i => <div className='button-wrapper' key={`${i.value}-wrapper`} id={`trending-time-range-${i.value}`}><Control
            key={i.value}
            text={i.title}
            value={i.value}
            selected={i.value === config.selected_timeframe}
            handleSelect={() => handleChangeTimeRange({selected_timeframe: i.value})}
            variant={'secondary'}
            addCheckWhenSelected={true}
          /></div>)}
        </Group>
      </SectionGroup>
      <SectionGroup>
        <SectionGroupDescription
          title='Placeholder images for articles without a header image, max size is 1MB'
        />
        <div className='inline'>
          <Group name={'controls images'}>
            {PLACEHOLDER_IMAGES_LIST.map(i => <Control
              key={i.value}
              text={i.title}
              value={i.value}
              selected={i.value === config.isCustomImage}
              handleSelect={() => handleChangePlaceholderImages({isCustomImage: i.value})}
              variant={'secondary'}
              addCheckWhenSelected={true}
            />)}
            {config.isCustomImage === 'CUSTOM' ? <ImageUploader
              supportedFileTypes={["image/jpeg", "image/png"]}
              maxSize={1000}
              imageSrc={uploadImagePreview}
              uploadImage={(value) => handleUpload(value)}
              discardFile={() => handleDiscard()}
            /> : null}
          </Group>
        </div>
      </SectionGroup>
    </SectionCard>
  );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default GeneralConfigs;

